import listRoutes from './search/pubsListRoutes';
import singlePubRoutes from './single-publication/singlePubRoutes';

const toBootstrap = [
  listRoutes,
  singlePubRoutes
];

function mainPubRoute($stateProvider) {
  $stateProvider
    .state('publications', {
      abstract: true,
      url: '/publications',
      template: '<div ui-view></div>',
      resolve: {
        loadModule: [
          '$ocLazyLoad',
          $ocLazyLoad => import('./publications')
            .then((pubsModule) => {
              $ocLazyLoad.load({ name: 'websked.publications' });
              return pubsModule;
            })
        ]
      }
    });
}

export default function (ngModule) {
  ngModule.config([
    '$stateProvider',
    mainPubRoute
  ]);

  toBootstrap.forEach((bootFn) => {
    bootFn(ngModule);
  });
}
